import Ajv from 'ajv';
import AjvErrorPlugin from 'ajv-errors';
import {
  defaultSchema,
  enhancedDisplaySchema,
  fullAdCarouselSchema,
  hostedVideoSchema,
  instreamVideoSchema,
  outstreamSchema,
  scrollerSchema,
  thumbnailCarouselSchema,
  videoCardSchema
} from './schema';

export const getValidationErrors = payload => {
  const ajv = new Ajv({ allErrors: true, jsonPointers: true });
  AjvErrorPlugin(ajv);
  const schema = getSchemaFor(payload);
  const valid = ajv.validate(schema, payload);

  return valid ? [] : ajv.errors;
};

const getSchemaFor = payload => {
  switch (payload.action) {
  case 'slideshow':
    return thumbnailCarouselSchema;
  case 'carousel':
    return fullAdCarouselSchema;
  case 'scroller':
    return scrollerSchema;
  case 'outstream':
    return outstreamSchema;
  case 'hosted-video':
    return hostedVideoSchema;
  case 'instream-video':
    return instreamVideoSchema;
  case 'banner':
    return enhancedDisplaySchema;
  case 'video':
    return videoCardSchema;
  default:
    return defaultSchema;
  }
};
